import { gql } from '@apollo/client';

export const GET_MITARBEITER_ARBEITSBEREICHE_BY_STANDORTID = gql`
  query mitarbeiter_getArbeitsbereicheByStandortId($standortId: String!) {
    mitarbeiter_arbeitsbereicheByStandortIds(standortIds: [$standortId]) {
      id
      name
      markierung
    }
  }
`;
